<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false"
  [closeOnEscape]="false"
  header="You've Been Idle!"
  styleClass="idle-timeout-dialog"
  [style]="{ width: '26rem' }"
>
  <div class="idle-body">
    <i class="pi pi-clock idle-icon"></i>
    <p class="idle-message">
      For your security, you'll be signed out in
      <strong>{{ countdown() }}</strong> second{{ countdown() === 1 ? '' : 's' }}
      due to inactivity.
    </p>
    <p class="idle-submessage">Do you want to stay signed in?</p>
  </div>

  <ng-template #footer>
    <p-button label="Logout" icon="pi pi-sign-out" severity="danger" [text]="true"
      (onClick)="logout()" />
    <p-button label="Stay Signed In" icon="pi pi-check" severity="success"
      (onClick)="stay()" />
  </ng-template>
</p-dialog>
